import React from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormSelect } from "../../../../components";
import {
  SOURCE_OPTIONS,
  EVENT_TYPE_OPTIONS,
  FORM_CONSTANTS,
} from "../SelectRules.constants";

interface ShoppingActivityFieldsProps {
  formValues: any;
}

const ShoppingActivityFields: React.FC<ShoppingActivityFieldsProps> = ({
  formValues,
}) => {
  const { control } = useFormContext();

  return (
    <>
      <Grid item xs={12}>
        <Controller
          name="source"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <FormSelect
              field={field}
              label="Source"
              placeholder="Select source"
              options={SOURCE_OPTIONS}
            />
          )}
        />
      </Grid>

      {formValues.source === FORM_CONSTANTS.SOURCES.SHOPIFY && (
        <Grid item xs={12}>
          <Controller
            name="event"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <FormSelect
                field={field}
                label="Event"
                placeholder="Select event"
                options={EVENT_TYPE_OPTIONS}
              />
            )}
          />
        </Grid>
      )}

      {formValues.event && (
        <Grid item xs={12}>
          <FormControl fullWidth disabled>
            <InputLabel id="from-label">From</InputLabel>
            <Select
              labelId="from-label"
              id="from-select"
              value={FORM_CONSTANTS.FROM_VALUES.START_OF_WORKFLOW}
              label="From"
              size="small"
            >
              <MenuItem value={FORM_CONSTANTS.FROM_VALUES.START_OF_WORKFLOW}>
                Start of Workflow
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
    </>
  );
};

export default ShoppingActivityFields;
